/**
 * The visible "Required" tag. Screen readers get the requirement from the control's own
 * `required` or `aria-required`, so the tag is hidden from them to avoid announcing it twice.
 */
export function RequiredMarker() {
  return (
    <span className="required-marker" aria-hidden="true">
      Required
    </span>
  );
}
